// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ProofMetric } from './proofMetric.zod.ts';

export const ProofOut = zod.object({
  "benchmarks": zod.array(ProofMetric),
  "cases": zod.int(),
  "client_measured": zod.array(ProofMetric),
  "targets": zod.array(ProofMetric)
});

export type ProofOut = zod.input<typeof ProofOut>;
export type ProofOutOutput = zod.output<typeof ProofOut>;
